import Link from "next/link";
import { CSSProperties } from "react";
import styles from "./button.module.scss";

interface ButtonProps {
  type: "fill" | "outline" | "ghost";
  size: "fullWidth" | "xLarge" | "large" | "medium" | "small";
  color?: "secondary" | "info" | "danger" | "success";
  text?: string;
  icon?: Icon;
  href?: string;
  disabled?: boolean;
  buttonType?: "submit" | "reset" | "button";
  customstyle?: CSSProperties;
  onClick?: (input: any) => void;
  
}

type ButtonElementProps = {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

type AnchorElementProps = {
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  href?: string;
  target?: string;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;

type ButtonOrAnchorProps = ButtonProps & (ButtonElementProps | AnchorElementProps);


interface Icon {
  path: string;
  alt: string;
  order: "before" | "after";
}

const iconSize = {
  fullWidth: 36,
  xLarge: 36,
  large: 32,
  medium: 24,
  small: 20
};

function Button({
  text,
  icon,
  type,
  size,
  href,
  color,
  buttonType = "button",
  customstyle,
  disabled = false,
  className,
  onClick
}: ButtonOrAnchorProps) {
  return (
    <>
      {!href ? (
        <button
          className={` ${className} ${styles.btn} ${styles[type]} ${styles[size]} ${
            styles[icon?.order || "unknown"]
          } ${styles[color || "unknown"]}`}
          disabled={disabled}
          style={customstyle}
          onClick={onClick}
          type={buttonType}
        >
          {text && <span>{text}</span>}
          {icon && (
            <span className={`${styles.wrapper_icon}`}>
              <img
                src={icon.path}
                alt={icon.alt}
                width={iconSize[size]}
                height={iconSize[size]}
              />
            </span>
          )}
        </button>
      ) : (
        <Link href={href} prefetch={false} onClick={onClick}>
          <a
            style={customstyle}
            className={` ${className} ${styles.btn} ${styles[type]} ${styles[size]} ${
              styles[icon?.order || "unknown"]
            } ${styles[color || "unknown"]}`}            
          >
            {text && <span>{text}</span>}
            {icon && (
              <span className={`${styles.wrapper_icon}`}>
                <img
                  src={icon.path}
                  alt={icon.alt}
                  width={iconSize[size]}
                  height={iconSize[size]}
                />
              </span>
            )}
          </a>
        </Link>
      )}
    </>
  );
}

export default Button;
